import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { AdditionalService } from '../../../services/additional.service';
import { RULES } from '../../../constants';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent implements OnInit {
  protected readonly RULES = RULES;

  form: FormGroup = new FormGroup(
    {
      oldPassword: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required, Validators.minLength(RULES.PASSWORD_MIN_LENGTH), Validators.maxLength(RULES.PASSWORD_MAX_LENGTH)]),
      confirmPassword: new FormControl('', [Validators.required])
    },
    { validators: this.additionalService.passwordMatchValidator('newPassword', 'confirmPassword') }
  );

  constructor(
    public userService: UserService,
    public readonly additionalService: AdditionalService,
    private readonly toastrService: ToastrService,
    private readonly translate: TranslateService,
    public dialogRef: MatDialogRef<ChangePasswordModalComponent>
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    if (!this.form.valid) {
      this.additionalService.markFormGroupAsDirty(this.form);
      return;
    }

    const formData = this.form.getRawValue();
    delete formData.confirmPassword;

    this.userService.changePasswordRequest(formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.toastrService.success(this.translate.instant('messages.password_changed'));
          this.dialogRef.close();
        } else {
          this.toastrService.error(this.translate.instant('messages.password_set_failed'));
        }
      }
    });
  }
}
